package team.platforma.multiplatform_material_extension.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.flow.update

@Deprecated("")
@Composable
fun rememberFormValidator(): State<FormValidator> {
    val scope = rememberCoroutineScope()
    return remember { mutableStateOf(FormValidator(scope)) }
}

@Composable
fun FormValidator.isValid(): Boolean {
    return this.validateForm.collectAsState().value
}

fun FormValidator.invalidateAll() {
    this.invalidateAllForm()
}

fun FormValidator.invalidateLast() {
    this.invalidateLastFormField()
}

@Composable
fun FormValidator.change(): Boolean {
    val changeForm = this.changeForm.collectAsState().value

    if (changeForm) {
        if (this.isValid()) {
            return true
        } else {
            return false
        }

    } else {
        if (this.isValid()) {
            return false
        } else {
            return false
        }
    }
}

@Composable
fun FormValidator.isEnabled(): Boolean {
    return this.formEnabled.collectAsState().value
}

fun FormValidator.setFormEnabled(boolean: Boolean) {
    this.formEnabled(boolean)
}

class FormValidator(scope: CoroutineScope) {
    private val mutableValidateState: MutableStateFlow<MutableMap<String, Boolean>> =
        MutableStateFlow(mutableMapOf())

    internal val validateForm: StateFlow<Boolean> = mutableValidateState
        .map { mutableMap -> mutableMap.values.all { it } }
        .stateIn(
            scope = scope,
            started = SharingStarted.Eagerly,
            initialValue = false
        )

    private val mutableChangeState: MutableStateFlow<MutableMap<String, String>> =
        MutableStateFlow(mutableMapOf())

    private var initMutableForm: MutableMap<String, String> = mutableMapOf()

    internal val changeForm: StateFlow<Boolean> = mutableChangeState
        .map { currentMutableMap ->

            initMutableForm.entries.any { (key, value) ->
                currentMutableMap[key] != value
            }

        }
        .stateIn(
            scope = scope,
            started = SharingStarted.Eagerly,
            initialValue = false
        )

    internal fun initFormString(key: String, string: String) {
        initMutableForm += (key to string)
    }

    internal fun changeFormString(key: String, string: String) {
        mutableChangeState.update { currentState ->
            currentState.toMutableMap().apply { this[key] = string }
        }
    }

    internal fun setValidateState(key: String, boolean: Boolean) {
        mutableValidateState.update { currentState ->
            currentState.toMutableMap().apply { this[key] = boolean }
        }
    }

    internal fun invalidateAllForm() {
        mutableValidateState.value.forEach {
            setValidateState(it.key, false)
        }
    }

    private var lastFocusFieldKey = ""
    internal fun setLastFocusField(key: String) {
        lastFocusFieldKey = key
    }

    internal fun invalidateLastFormField() {
        mutableValidateState.value.forEach {
            if (it.key == lastFocusFieldKey) {
                setValidateState(it.key, false)
            }

        }
    }


    private val mFormEnabled = MutableStateFlow(true)
    internal val formEnabled: StateFlow<Boolean> = mFormEnabled
    internal fun formEnabled(boolean: Boolean) {
        mFormEnabled.value = boolean
    }

}


